const ClientSimpleBarChart = ({ data = [], labelKey = "label", valueKey = "value", title }) => {
  if (!data.length) {
    return <p className="muted">No data for this period.</p>;
  }

  const max = Math.max(...data.map((d) => d[valueKey] || 0), 1);

  return (
    <div className="client-simple-chart" role="img" aria-label={title || "Bar chart"}>
      {title ? <h4>{title}</h4> : null}
      <ul className="client-simple-chart__bars">
        {data.map((item) => {
          const value = item[valueKey] || 0;
          const pct = Math.round((value / max) * 100);
          return (
            <li key={item[labelKey]} className="client-simple-chart__row">
              <span className="client-simple-chart__label">{item[labelKey]}</span>
              <span className="client-simple-chart__track">
                <span className="client-simple-chart__fill" style={{ width: `${pct}%` }} />
              </span>
              <span className="client-simple-chart__value">{value}</span>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ClientSimpleBarChart;
